<template>
    <span v-if="visible" class="d-inline-flex align-items-stretch align-middle ml-2" :style="containerStyle" :title="tooltip">
        <template v-if="expired">
            <span class="d-inline-flex align-items-center"
                :style="[boxStyle, { fontWeight: 700, fontSize: '15px', padding: '4px 10px' }]">
                <i class="fas fa-stopwatch mr-2" style="font-size: 17px;"></i>
                Tiempo de gestión vencido
            </span>
        </template>
        <template v-else>
            <span class="d-inline-flex align-items-center justify-content-center" :style="boxStyle">
                <i class="fas fa-stopwatch" style="font-size: 18px;"></i>
            </span>
            <span v-for="(unit, i) in units" :key="i"
                class="d-inline-flex flex-column align-items-center justify-content-center"
                :style="boxStyle">
                <span :style="{ fontWeight: 700, fontSize: '17px', lineHeight: '1.1' }">{{ unit.value }}</span>
                <span :style="{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px', opacity: 0.75 }">{{ unit.label }}</span>
            </span>
        </template>
    </span>
</template>

<script>
export default {
    name: "ManagementCountdownBadge",
    props: {
        // Fecha/hora límite (ISO) proveniente de la muestra.
        deadline: { type: String, default: null },
        // Estado de la muestra (numérico). Solo se muestra entre Enviado (1) y antes de Despachado Bodega (6).
        sampleState: { type: [Number, String], default: null },
    },
    data() {
        return { now: Date.now(), timer: null };
    },
    computed: {
        stateNum() {
            return this.sampleState === null || this.sampleState === "" ? null : Number(this.sampleState);
        },
        visible() {
            return !!this.deadline && this.stateNum !== null && this.stateNum >= 1 && this.stateNum < 6;
        },
        remaining() {
            if (!this.deadline) return 0;
            return new Date(this.deadline).getTime() - this.now;
        },
        expired() {
            return this.remaining <= 0;
        },
        days() {
            return Math.floor(this.remaining / 86400000);
        },
        hours() {
            return Math.floor((this.remaining % 86400000) / 3600000);
        },
        minutes() {
            return Math.floor((this.remaining % 3600000) / 60000);
        },
        seconds() {
            return Math.floor((this.remaining % 60000) / 1000);
        },
        units() {
            return [
                { value: this.pad(this.days), label: "días" },
                { value: this.pad(this.hours), label: "hrs" },
                { value: this.pad(this.minutes), label: "min" },
                { value: this.pad(this.seconds), label: "seg" },
            ];
        },
        // Color por urgencia: teal normal, ámbar en las últimas 24h, rojo si venció.
        theme() {
            if (this.expired) return { text: "#b91c1c", border: "#fca5a5", bg: "#fef2f2" };
            if (this.remaining < 86400000) return { text: "#b45309", border: "#fcd34d", bg: "#fffbeb" };
            return { text: "#0f766e", border: "#17B8AB", bg: "#f0fdfa" };
        },
        // Barra gruesa de fondo (color del borde) que une las cajitas.
        containerStyle() {
            return {
                background: this.theme.border,
                padding: "5px",
                borderRadius: "10px",
                gap: "6px",
            };
        },
        // Estilo base compartido por todas las cajitas (icono, unidades y "vencido").
        // Sin borde propio: la "barra" del contenedor es la que las une visualmente.
        boxStyle() {
            return {
                color: this.theme.text,
                background: this.theme.bg,
                borderRadius: "6px",
                padding: "3px 6px",
                minWidth: "38px",
            };
        },
        tooltip() {
            if (this.expired) return "Tiempo de gestión vencido";
            return `Tiempo restante de gestión: ${this.days} Días ${this.hours} Horas ${this.minutes} minutos ${this.seconds} segundos`;
        },
    },
    methods: {
        pad(n) {
            return String(Math.max(0, n)).padStart(2, "0");
        },
    },
    mounted() {
        this.timer = setInterval(() => {
            this.now = Date.now();
        }, 1000);
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer);
    },
};
</script>
